import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useChangeAddressStepHook } from '../logic/useStepHook';
import { FormView } from './FormView';

export const AddressFormStep = ({ control }: any) => {
  const { t } = useTranslation();
  const { getValues, watch, setError } = useFormContext();
  const { handleForward } = useChangeAddressStepHook({ setError });
  const handleConfirm = useCallback(() => {
    handleForward();
  }, [getValues, watch]);
  return (
    <FormView
      isLoading={false}
      buttonTitle={t('CHANGE_ADDRESS.FORM.BUTTON_TITLE')}
      handleClick={handleConfirm}
      control={control}
    />
  );
};
